import React from 'react'
import './AcceptableTerms.css'

const AcceptableTerms = ({ transporter_data }) => {
    const acceptableterms = transporter_data?.acceptable_terms ?? 'Details not available'
    const hasTerms = acceptableterms && acceptableterms !== 'Details not available'

    return (
        <div className="acceptabletermscard">
            <div className="acceptabletermscontainer row" id="style-2">
                <div className="col-12">
                    <span className="data_header"><b>Acceptable Terms</b></span>
                    {!hasTerms ? (
                        <div className="acceptabletermsparagraph">Details not available</div>
                    ) : (
                        <div className="acceptabletermsparagraph">
                            {acceptableterms.payment_terms && <p className="acc_term"><b>Payment Terms: </b>{acceptableterms.payment_terms}</p>}
                            {acceptableterms.cargo_insured && <p className="acc_term"><b>Cargo Insured by Customer: </b>{acceptableterms.cargo_insured}</p>}
                            {acceptableterms.loading_unloading_charges && <p className="acc_term"><b>Loading/Unloading charges by Customer: </b>{acceptableterms.loading_unloading_charges}</p>}
                            {acceptableterms.detention_charges && <p className="acc_term"><b>Detention Charges: </b>{acceptableterms.detention_charges}</p>}
                            {acceptableterms.other_terms && <p className="acc_term"><b>Other Terms: </b>{acceptableterms.other_terms}</p>}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AcceptableTerms
